module.exports = "/static/assets/8fed622c4d818b24664982cc8590128c.png";